/**
 * Компонент для отображения одного критерия Query Builder
 */

import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Button, Space } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { QueryBuilderStore } from "../../QueryBuilderStore";
import { ZCriterionNode, ZNodePath } from "../../types";
import { CriterionEditor } from "../CriterionEditor/CriterionEditor";
import * as styles from "./CriterionItem.module.less";

interface PropsCriterionItem {
  /** Узел-критерий */
  criterion: ZCriterionNode;

  /** Путь к критерию в дереве */
  path: ZNodePath;

  /** Store для управления деревом */
  store: QueryBuilderStore;

  /** Можно ли переместить критерий вверх */
  canMoveUp: boolean;

  /** Можно ли переместить критерий вниз */
  canMoveDown: boolean;

  /** Можно ли удалять критерий */
  canDelete: boolean;

  /** Обернуть критерий в группу условий */
  onWrapInGroup: () => void;
}

/**
 * Компонент отображения критерия с панелью управления
 */
export const CriterionItem: React.FC<PropsCriterionItem> = observer(
  ({
    criterion,
    path,
    store,
    canMoveUp,
    canMoveDown,
    canDelete,
    onWrapInGroup,
  }) => {
    // Обработчики действий
    const handleRemove = () => {
      store.removeCriterion(path);
    };

    const handleMoveUp = () => {
      store.moveNodeUp(path);
    };

    const handleMoveDown = () => {
      store.moveNodeDown(path);
    };

    return (
      <div className={styles.criterionItem}>
        <div className={styles.criterionContent}>
          <div className={styles.criterionBody}>
            <CriterionEditor criterion={criterion} path={path} store={store} />
          </div>

          <div className={styles.criterionActions}>
            <Space size="small">
              <Button
                size="small"
                type="link"
                onClick={onWrapInGroup}
                className={styles.addGroupAfterBtn}
                title="Обернуть условие в группу"
              >
                +()
              </Button>
              <Button
                size="small"
                icon={<DeleteOutlined />}
                onClick={handleRemove}
                disabled={!canDelete}
                title={
                  canDelete
                    ? "Удалить условие"
                    : "Нельзя удалить последнее условие"
                }
              />
              <Button
                size="small"
                icon={<ArrowUpOutlined />}
                onClick={handleMoveUp}
                disabled={!canMoveUp}
                title="Переместить вверх"
              />
              <Button
                size="small"
                icon={<ArrowDownOutlined />}
                onClick={handleMoveDown}
                disabled={!canMoveDown}
                title="Переместить вниз"
              />
            </Space>
          </div>
        </div>
      </div>
    );
  },
);
